<div style="display:flex; flex-direction:row; flex-grow:1; overflow:hidden;">
    <div style="display:flex; flex-direction:column; flex:1; overflow:hidden;">
        <tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf">
            <div class="flex-header">
                <student-header [pageTitle]="''" style="width:100%">
                </student-header>
                <div>
                    <div style="display: flex;justify-content: flex-end;">
                        <page-header [pageTitle]="'Forms Within Document'" style="padding-top: 10px;width:50%">
                        </page-header>
                    </div>
                    <div style="margin-top: 5px; margin-bottom: 5px;text-align: right ">
                        <span style="font-weight: bold;">{{collectionName}}</span>&nbsp;&nbsp;&nbsp;
                        Status<span style="font-weight: bold;"> {{status}}</span>
                    </div>
                </div>
            </div>

            <div class="flex-content" style="height: 200%;">
                <div style="overflow:auto;">
                    <mat-table style="width:100%;" #sort="matSort" matSort [dataSource]="tylerMatData"
                        multiTemplateDataRows cdkDropList (cdkDropListDropped)="rowDrop($event)"
                        class="mat-elevation-z8" matSort matSortDisableClear matSortDirection="asc">


                        <ng-container matColumnDef="dragHandle">
                            <mat-header-cell *matHeaderCellDef>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element let i = index;" cdkDragHandle>
                                <span><img alt="Re-Order" title="Re-Order" *ngIf="element.IsAllowMultiple == true"
                                        style="align-items: flex-start; margin-top: 8px" src="./assets/images/grip.png"
                                        style="width: 10px"></span>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="CheckAllStatus">
                            <mat-header-cell *matHeaderCellDef>
                                <tyl-checkbox id='chkStatus' name="chkStatus" (change)="checkAllClick()"
                                    [(checked)]="allCheck">
                                </tyl-checkbox>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" style="align-items: flex-start; margin-top: 8px">
                                <tyl-checkbox (change)="chkSingleForm()" [(checked)]="element.StatusChecked">
                                </tyl-checkbox>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="More">
                            <mat-header-cell *matHeaderCellDef
                                style="min-width:68px; max-width:68px; text-align:center;" translate
                                class="print-ignore">
                                <span aria-label="Expand row for more details">
                                    <i [ngClass]="expandAllRow ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'"
                                        class="material-icons" (click)="expandAllRowClick()" aria-hidden="true"></i>
                                </span>
                            </mat-header-cell>

                            <mat-cell *matCellDef="let element"
                                style="min-width:75px;max-width:75px;text-align:center;color:black;align-items: flex-start; margin-top: 8px"
                                class="print-ignore">
                                <span aria-label="Expand row for more details"
                                    *ngIf="element.DoumentName.indexOf('MO_5_IEPGoalMaint') > 0 || element.DoumentName.indexOf('IL_5_IEPGoalObjectives') > 0 || element.DoumentName.indexOf('NM_10_IEPGoalMaint') > 0 || element.DoumentName.indexOf('OR_6_IEPAAFGO') > 0">
                                    <i [ngClass]="checkExpanded(element) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'"
                                        class="material-icons" aria-hidden="true"></i>
                                </span>
                            </mat-cell>
                        </ng-container>


                        <ng-container matColumnDef="TemplateNameHTML">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>
                                <span translate>Form Name</span>
                                <filter class="mat-filter" [data]="tylerMatData" columnName="TemplateNameHTML"
                                    dataType="string">
                                </filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" style="align-items: flex-start; margin-top: 8px">
                                {{element.TemplateNameHTML}} </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="CheckedOutByuserName">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>
                                <span translate>Checked-Out By</span>
                                <filter class="mat-filter" [data]="tylerMatData" columnName="CheckedOutByuserName"
                                    dataType="string">
                                </filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" style="align-items: flex-start; margin-top: 8px">
                                {{element.CheckedOutByuserName}} </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="IsOptional">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>
                                <span translate>Optional</span>
                                <filter class="mat-filter" [data]="tylerMatData" columnName="IsOptional"
                                    dataType="boolean" [trueValue]="'true'" [falseValue]="'false'" [showTrueLabel]="'Y'"
                                    [showFalseLabel]="''">
                                </filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element"
                                style="padding-left: 30px;align-items: flex-start; margin-top: 8px">
                                {{element.IsOptional == true ? 'Y' : ''}} </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="IsAllowMultiple">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>
                                <span translate>Allow Multiple</span>
                                <filter class="mat-filter" [data]="tylerMatData" columnName="IsAllowMultiple"
                                    dataType="boolean" [trueValue]="'true'" [falseValue]="'false'" [showTrueLabel]="'Y'"
                                    [showFalseLabel]="''">
                                </filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element"
                                style="padding-left: 30px;align-items: flex-start; margin-top: 8px">
                                {{element.IsAllowMultiple == true ? 'Y' : ''}} </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="LastModifiedDate">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>
                                <span translate>Last Modified</span>
                                <filter [data]="tylerMatData" columnName="LastModifiedDate" dataType="date"
                                    id="LastModifiedDateFilter" class="mat-filter">
                                </filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" style="align-items: flex-start; margin-top: 8px">
                                {{element.LastModifiedDate | date: 'MM/dd/yy' }} </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="ModifiedByUserName">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>
                                <span translate>Modified By</span>
                                <filter class="mat-filter" [data]="tylerMatData" columnName="ModifiedByUserName"
                                    dataType="string">
                                </filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" style="align-items: flex-start; margin-top: 8px">
                                {{element.ModifiedByUserName}} </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="IsMarkedComplete">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>
                                <span translate>Completed</span>
                                <filter class="mat-filter" [data]="tylerMatData" columnName="IsMarkedComplete"
                                    dataType="boolean" [trueValue]="'true'" [falseValue]="'false'" [showTrueLabel]="'Y'"
                                    [showFalseLabel]="''">
                                </filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element"
                                style="padding-left: 30px;align-items: flex-start; margin-top: 8px">
                                {{element.IsMarkedComplete == true ? 'Y' : ''}} </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Actions">
                            <mat-header-cell *matHeaderCellDef>
                                <span translate>Actions</span>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element let i = index;" class="print-ignore"
                                style="align-items: flex-start; margin-top: 8px">
                                <tyl-mat-menu id="actionMenu{{i}}" image="actions.png">
                                    <button id="duplicate{{i}}" mat-menu-item class="menuItem"
                                        *ngIf="element.IsAllowMultiple == true && allowDeleteFinalStatus()"
                                        (click)="copyOfForm(element)">
                                        Duplicate
                                    </button>
                                    <button
                                        *ngIf="allowToEditDelete(element) && element.DoumentName.includes('MO_37_IEP') == false"
                                        id="edit{{i}}" mat-menu-item class="menuItem"
                                        (click)="viewEditForm(element, 'Edit')">
                                        Edit
                                    </button>
                                    <button id="print{{i}}" mat-menu-item class="menuItem"
                                        (click)="viewContent(element, true)">
                                        Print
                                    </button>
                                    <button id="withoutWorkingDraft{{i}}"
                                        *ngIf="status == 'Working Draft' && printWithoutWorkingDraft" mat-menu-item
                                        class="menuItem" (click)="viewContent(element, false)">
                                        Print Without Working Draft
                                    </button>
                                    <button id="view{{i}}" *ngIf="element.DoumentName.includes('MO_37_IEP') == false"
                                        mat-menu-item class="menuItem" (click)="viewEditForm(element, 'View')">
                                        View
                                    </button>
                                    <mat-divider *ngIf="allowToEditDelete(element) && element.IsOptional">
                                    </mat-divider>
                                    <button id="delete{{i}}" *ngIf="allowToEditDelete(element) && element.IsOptional"
                                        mat-menu-item class="menuItem" (click)="deleteFormOfDocument(element)">
                                        Delete
                                    </button>
                                    <mat-divider *ngIf="allowToEditDelete(element)">
                                    </mat-divider>
                                    <button id="markedComplete{{i}}"
                                        *ngIf="allowToEditDelete(element) && !element.IsMarkedComplete" mat-menu-item
                                        class="menuItem" (click)="markComplete(element, true)">
                                        Mark Completed
                                    </button>
                                    <button id="unMarkedComplete{{i}}"
                                        *ngIf="allowToEditDelete(element)  && element.IsMarkedComplete" mat-menu-item
                                        class="menuItem" (click)="markComplete(element, false)">
                                        Unmark Completed
                                    </button>
                                </tyl-mat-menu>
                                <!-- [disabled]="!element.IsOptional" -->
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="expandedDetail">
                            <td mat-cell *matCellDef="let element" [attr.colspan]="columnToDisplay.length"
                                style="width:100%;margin-left: 70px;"
                                (click)="element.DoumentName.includes('MO_5_IEP') == true ? element : null"
                                class="mat-detail-card">
                                <div style="margin-left: 20px;">{{element.ToolTip}}</div>
                            </td>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="columnToDisplay;" id="Documentheader">
                        </mat-header-row>
                        <mat-row *matRowDef="let row; columns: columnToDisplay; let i = index;" tabindex="0"
                            (click)="toggleExpanded(row)" style="padding:0px;overflow:hidden;border-bottom-width:1px;"
                            class="element-row" matRipple cdkDrag [cdkDragData]="row"
                            [cdkDragDisabled]="row.IsAllowMultiple == false">

                        </mat-row>
                        <mat-row *matRowDef="let row; columns: ['expandedDetail']"
                            [@detailExpand]="checkExpanded(row) ? 'expanded' : 'collapsed'" style="overflow: hidden"
                            class="mat-detail-row">
                        </mat-row>
                    </mat-table>
                </div>
            </div>
            <br>
            <div *ngIf="importedDocuments.length > 0">
                <div style="display:flex;">
                    <div style="display:flex;; padding-left: 30px;">
                        <mat-divider style=" margin-top: 20px;">
                        </mat-divider>
                        <span style="padding-top: 8px;font-weight: bold;">
                            Attachments
                        </span>
                    </div>
                </div>
                <!--attachement grid--->
                <div class="flex-content" style="display:flex;height: 100%;">
                    <div style="overflow: auto;">
                        <mat-table #table [dataSource]="matDataSource" style="min-height: 100px; max-height:380px;"
                            multiTemplateDataRows #sort2="matSort" matSort matSortDisableClear matSortDirection="asc"
                            *ngIf="importedDocuments.length > 0">
                            <ng-container matColumnDef="Description">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Description
                                    <filter [data]="matDataSource" columnName="Description" dataType="string"
                                        id="studentNameFilter" class="mat-filter">
                                    </filter>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <a (click)="viewDocumentClick(element)" style="cursor: pointer;">
                                        {{element.Description}}
                                    </a>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="DocumentName">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                    File Name
                                    <filter [data]="matDataSource" columnName="DocumentName" dataType="string"
                                        id="studentStrIDFilter" class="mat-filter">
                                    </filter>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    {{element.DocumentName}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="CreatedDate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Uploaded
                                    <filter [data]="matDataSource" columnName="CreatedDate" dataType="date"
                                        id="createdFilter" class="mat-filter">
                                    </filter>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    {{element.CreatedDate | date: 'MM/dd/yy'}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="UserName">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Uploaded By
                                    <filter [data]="matDataSource" columnName="UserName" dataType="string"
                                        id="siteCodeFilter" class="mat-filter">
                                    </filter>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    {{element.UserName}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="Actions" *ngIf="deleteDocumentPer || deleteDocumentPer504">
                                <mat-header-cell *matHeaderCellDef class="action-header">
                                    Actions
                                </mat-header-cell>
                                <mat-cell *matCellDef="let element let i = index;">
                                    <a id="delete{{i}}" (click)="deleteImportedDocuments(element)">Delete</a>
                                </mat-cell>
                            </ng-container>

                            <mat-header-row *matHeaderRowDef="columnToDisplayImported sticky:true">
                            </mat-header-row>
                            <mat-row *matRowDef="let row; columns:columnToDisplayImported; let i = index"
                                id="currentWorkGridRow{{i}}" matRipple class="element-row">
                            </mat-row>
                        </mat-table>
                    </div>
                </div>
            </div>
        </tyl-kendo-pdf-export>
        <div class="flex-footer">
            <div class="flex-footer-left">
                <tyl-button image="checkbox multi.png" label="Mass Actions" [matMenuTriggerFor]="actionMenu"
                    (click)="$event.stopPropagation();massAction()"></tyl-button>
                <mat-menu #actionMenu="matMenu">
                    <button id="errormsg" *ngIf="disabledActionMenuItems" mat-menu-item style="line-height:normal;"
                        class="menuItem">
                        <span style="cursor:pointer;color: red; font-weight: bold; ">At least one checkbox must be
                            selected in
                            order to use
                            Mass Actions options:</span>
                    </button>
                    <button id="errormsg" mat-menu-item style="line-height:normal;" class="menuItem"
                        [disabled]="disabledActionMenuItems">
                        <span style="cursor:pointer" (click)="viewMassContent(true)">Mass Print</span>
                    </button>
                    <button id="revertDraft" mat-menu-item class="menuItem"
                        *ngIf="status == 'Working Draft' && printWithoutWorkingDraft"
                        [disabled]="disabledActionMenuItems" (click)="viewMassContent(false)">
                        Mass Print Without Working Draft
                    </button>
                </mat-menu>
                <tyl-button image="add.png" label="Add Optional Forms" disabledImage="add disabled.png"
                    [disabled]="viewOnly" (clickEvent)="addOptionalForms()" *ngIf="allowToAddOptionalForm()">
                </tyl-button>
                <tyl-button image="add.png"
                    *ngIf="((importDocumentAndAttachToAllSpEdDocuments && !collectionCode.includes('504')) || (importDocumentAndAttachToAllSpEdDocuments504 && collectionCode.includes('504'))) && !inactiveSpEdModule"
                    label="Add Attachment" (clickEvent)="addAttachment()"></tyl-button>
                <tyl-button image="changerecipientsnocircle.png" style="padding-top: 5px;"
                    disabledImage="change recipients disabled.png"
                    [disabled]="(!maintainTeamMemberPermission && !isDocCreator)" (clickEvent)="maitainTeamClick()"
                    label="Maintain Teams">
                </tyl-button>
            </div>
            <div class="flex-footer-middle" style="align-items: center; z-index: 1;margin-right: 45px;">
                <filter-notification [filtered]=" isFiltered || tylerMatData.isFiltered() || matDataSource.isFiltered()"
                    (clearFilter)="clearFilterFromFooter()"></filter-notification>
            </div>
            <div class="flex-footer-right" *ngIf="!showAsOverlayDialog">
                <tyl-mat-menu id="quickNavigateMenuButton" image="icons/baseline_menu.png" label="Quick Navigation">
                    <button id="errormsg" mat-menu-item style="line-height:normal;" class="menuItem">
                        <span style="cursor:pointer" (click)="specialServiceHome()">Special Services Home</span>
                    </button>
                    <button id="revertDraft" mat-menu-item class="menuItem" (click)="studentDocument()">
                        Special Services Documents
                    </button>
                </tyl-mat-menu>
            </div>
        </div>
    </div>
</div>